<section class="login-register">
  <aside class="login-sidebar">
    <a href="javascript:void(0)" id="logo" class="login-logo">
      <img src="/assets/img/barkani_logo_white.svg" alt="{{COMPANY_NAME}}" />
    </a>
    <div id="text" class="login-mission">
      <p class="login-mission__eyebrow">Our Mission</p>
      <p class="login-mission__headline">Improving Lives by Advancing Healthcare Stakeholder Engagement</p>
      <p class="login-mission__desc">
        Dedicated to improving people&rsquo;s lives, {{COMPANY_NAME}} creates and advances the
        integrated technologies that strengthen collaboration among
        <strong class="login-mission__p">P</strong>atients,
        <strong class="login-mission__p">P</strong>roducers,
        <strong class="login-mission__p">P</strong>rescribers,
        <strong class="login-mission__p">P</strong>roviders,
        <strong class="login-mission__p">P</strong>ayors, and
        <strong class="login-mission__p">P</strong>artners.
      </p>
    </div>
    <footer class="login-footer">
      &copy; 2026 {{COMPANY_SITE}}
    </footer>
  </aside>

  <div class="login-box">
    <app-sandbox-banner [compact]="true"></app-sandbox-banner>
    <nav class="login-nav" aria-label="Barkani website">
      <a href="https://www.barkani.com/" target="_blank" rel="noopener noreferrer">Home</a>
      <a href="https://www.barkani.com/platform" target="_blank" rel="noopener noreferrer">Platform</a>
      <a href="https://www.barkani.com/about" target="_blank" rel="noopener noreferrer">About</a>
      <a href="https://www.barkani.com/contact-us" target="_blank" rel="noopener noreferrer">Contact</a>
    </nav>
    <div class="login-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</section>
